import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../../../common/config";

export const forgetPasswordService = createApi({
  reducerPath: "forget Password",
  baseQuery,
  endpoints: (builder) => ({
    forgetPassword: builder.mutation({
      query: (formdata) => ({
        url: "/api/users/resetpassword",
        method: "POST",
        body: formdata,
      }),
    }),
  }),
});
export const { useForgetPasswordMutation } = forgetPasswordService;
